/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidatorListRequest
 */
export interface ValidatorListRequest {
    /**
     * 
     * @type {string}
     * @memberof ValidatorListRequest
     */
    orderBy: string;
    /**
     * 
     * @type {string}
     * @memberof ValidatorListRequest
     */
    sort: string;
}

export function ValidatorListRequestFromJSON(json: any): ValidatorListRequest {
    return ValidatorListRequestFromJSONTyped(json, false);
}

export function ValidatorListRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidatorListRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'orderBy': json['orderBy'],
        'sort': json['sort'],
    };
}

export function ValidatorListRequestToJSON(value?: ValidatorListRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'orderBy': value.orderBy,
        'sort': value.sort,
    };
}


